import React from 'react'

import FormManager from "../../../../../../core/gd-form/common/form-manager"
import MultiselectOptions from "../../../../../../core/gd-ui/side-filters/multiselect-options/multiselect-options"
import {EventType} from "../../../../../../core/gd/const/event"
import FormError from "../../../../../../core/gd-form/common/form-error/form-error"
import CustomView_rowComponent from "../forms/common-blocks/row-component"

type Props = {
    form            : FormManager
    formFieldName   : string

    disabled?       : boolean
}

// const debug = "SummaryEventTypesBlock"
const debug = false

export default function SummaryEventTypesBlock(props: Props) {

    debug && console.log(debug, 'render', props)

    const onMultiselectSelect = (options: any) => {
        props.form.onFormComponentValueChange(props.formFieldName, options)
    }

    const eventTypes = props.form.getValue(props.formFieldName);

    const eventTypesOptions = gd.const.event.exportToOptions([
        EventType.PROJECT_EVENT,
        EventType.PROJECT_MILESTONE,
        EventType.PROJECT_DEADLINE,
        // EventType.PROJECT_CREATED,
        // EventType.PROJECT_PAYMENT,
        EventType.COMPANY_EVENT,
        EventType.COMPANY_HOLIDAY,
        EventType.TASK_DEADLINE,
    ]);

    return (
        <CustomView_rowComponent label="Event type">
            <MultiselectOptions type                = "form"
                                title               = ""
                                filterTypes         = {eventTypes}
                                typeFilterValues    = {eventTypesOptions}
                                isFoldable          = {false}
                                onSelect            = {onMultiselectSelect}/>
            <FormError form = {props.form}
                       name = {props.formFieldName}/>
        </CustomView_rowComponent>
    )
}